export default __webpack_public_path__ + "static/media/poster-background.05232add.png";